import { Injectable } from '@angular/core';
import {
  getValue,
  isDefined,
  isDefinedAndFilledArray,
  isUndefinedOrNull,
} from '../../../../shared/utility/verify.lib';
import { IProductItem } from '../../../../models/item/product-item.model';
import { IItemName } from '../../../../models/item/item-name.model';

@Injectable({
  providedIn: 'root',
})
export class ProductItemHelperService {
  constructor() {}

  public updateActiveLanguageTextForProduct(
    documentItems: IProductItem[],
    activeLanguage: string
  ): Record<string, string> {
    const productItemTextInActiveLanguage: Record<string, string> = {};

    if (isDefinedAndFilledArray(() => documentItems)) {
      documentItems.forEach((item: IProductItem) => {
        if (isDefinedAndFilledArray(() => item.names)) {
          const posNumber: string = getValue(() => item.posNumber);
          const foundLanguageText: IItemName = item.names.find(
            (itemName: IItemName) =>
              getValue(() => itemName.language) === activeLanguage &&
              isDefined(() => itemName.text)
          );
          const defaultLanguageText: IItemName = item.names.find(
            (itemName: IItemName) => getValue(() => itemName.language) === 'EN'
          );
          productItemTextInActiveLanguage[posNumber] = isDefined(
            () => foundLanguageText.text
          )
            ? foundLanguageText.text
            : getValue(() => defaultLanguageText.text, null);
        }
      });
    }

    return productItemTextInActiveLanguage;
  }

  public updateSelectableProductItems(
    documentItems: IProductItem[]
  ): Record<string, boolean> {
    const isProductItemHasDocuments: Record<string, boolean> = {};

    if (isDefinedAndFilledArray(() => documentItems)) {
      documentItems.forEach((item: IProductItem) => {
        const posNumber: string = getValue(() => item.posNumber, null);
        isProductItemHasDocuments[posNumber] =
          isUndefinedOrNull(() => item.hasNoDocuments) ||
          item.hasNoDocuments === false;
      });
    }

    return isProductItemHasDocuments;
  }

  public countOfSelectedProduct(
    isProductItemChecked: Record<string, boolean>
  ): number {
    return isDefinedAndFilledArray(() => isProductItemChecked)
      ? Object.values(isProductItemChecked).filter(
          (isChecked: boolean) => isChecked
        )?.length
      : 0;
  }
}
